import { SalaryScaleGroupService, ISalaryScaleGroup } from "../../../services/salaryScaleGroup.service";
import { HourCodeService, IHourCode } from "../../../services/hourCode.service";

class HourCodesListController implements ng.IComponentController {
    sortType: string;
    salaryScaleGroups: ISalaryScaleGroup[];
    selectedGroup: ISalaryScaleGroup;
    hourCodes: IHourCode[] = [];

    constructor(
        private SalaryScaleGroupService: SalaryScaleGroupService,
        private HourCodeService: HourCodeService,
        private $state: ng.ui.IStateService,
        private $stateParams: ng.ui.IStateParamsService
    ) {
        'ngInject';

        this.sortType = 'name';
    }

    public $onInit = () => {
        console.log('HourCodesListController initialized');
        // Reset hourCodes array to ensure it's empty initially
        this.hourCodes = [];
        this.loadSalaryScaleGroups();
    }

    private loadSalaryScaleGroups = () => {
        console.log('Loading salary scale groups...');
        this.SalaryScaleGroupService.all().then((result: ISalaryScaleGroup[]) => {
            console.log('Salary scale groups loaded:', result);
            // Sort alphabetically by name
            this.salaryScaleGroups = result.sort((a, b) => {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
            });
            
            // Restore selectedGroup from state params if available
            const selectedGroupId = this.$stateParams['selectedCaoId'];
            if (selectedGroupId) {
                const group = this.salaryScaleGroups.find(g => g.id === selectedGroupId);
                if (group) {
                    this.selectedGroup = group;
                    this.loadHourCodes(group.id);
                } else {
                    // Group not found, clear selection
                    this.selectedGroup = null;
                    this.hourCodes = [];
                }
            } else {
                // No group selected, ensure hourCodes is empty
                this.selectedGroup = null;
                this.hourCodes = [];
            }
        });
    }

    private loadHourCodes = (salaryScaleGroupId: string) => {
        this.HourCodeService.getBySalaryScaleGroupId(salaryScaleGroupId).then((result: IHourCode[]) => {
            this.hourCodes = result || [];
        });
    }

    public clearSelection = () => {
        this.selectedGroup = null;
        this.hourCodes = [];
        // Clear selected CAO ID from state params
        this.$state.go('settings.hourcodes.list', { 'selectedCaoId': null }, { location: 'replace', notify: false });
    }

    public onGroupChange = (selectedGroup: ISalaryScaleGroup) => {
        this.selectedGroup = selectedGroup;
        if (selectedGroup && selectedGroup.id) {
            this.loadHourCodes(selectedGroup.id);
            // Save selected CAO ID to state params
            this.$state.go('settings.hourcodes.list', { 'selectedCaoId': selectedGroup.id }, { location: 'replace', notify: false });
        } else {
            this.hourCodes = [];
            this.$state.go('settings.hourcodes.list', { 'selectedCaoId': null }, { location: 'replace', notify: false });
        }
    }

    public addHourCode = () => {
        if (!this.selectedGroup || !this.selectedGroup.id) {
            alert('Geen CAO geselecteerd. Selecteer eerst een CAO om een uurcode toe te voegen.');
            return;
        }
        this.$state.go('settings.hourcodes.list.item', { 'id': '', 'caoId': this.selectedGroup.id });
    }
}

export const hourCodesListComponent: ng.IComponentOptions = {
    controller: HourCodesListController,
    bindings: {},
    template: require('./hourCodes.list.html')
};




// WEBPACK FOOTER //
// ./src/app/modules/settings/hourCodes/hourCodes.list.component.ts